module.exports = __webpack_public_path__ + "img/Genrate Ticket.ab15e258.svg";